// src/API/Address/RequestDeleteAddressAsync.ts
import { getApiBaseUrl } from "../../utils/apiBaseUrl";


/**
 * @param addressId - The ID of the address to delete.
 * @param deleteReason - The reason for deleting the address.
 * @param token - The user's authentication token.
 * @returns A promise that resolves to the API response.
 */
export async function requestDeleteAddressAsync(
    addressId: number,
    deleteReason: string,
    token: string
  ): Promise<any> {
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(`${baseUrl}/api/address/RequestDeleteAddressAsync`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          addressId,
          deleteReason,
        }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`);
      }
  
      const result = await response.json();
      return result;
    } catch (error) {
      // console.error("Error sending delete request:", error);
      throw error;
    }
  }
  